<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />
          {{ /* table controllerscontrollers */ }}
          <div>
            <div class="form-group form-inline pull-left">
              <b-dropdown id="dropdown-1" variant="primary" size="sm" class="vgt-left-btn" no-caret>
                <template slot="button-content">
                  Update Store
                </template>
                <span v-for="integration in integrations" :key="integration.id">
                  <b-dropdown-item @click="sync(integration.id)">
                    <b-img :src="integration.marketplace_logo" height="32" />
                    <strong>{{ integration.nickname ? integration.nickname : integration.name }}</strong>
                    &nbsp;&nbsp;
                    <span class="glyphicon glyphicon-refresh"></span>
                    <br />
                    <em> Last Updated: {{ integration.last_synced_at | readableDate }}</em>
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                </span>
              </b-dropdown>
              &nbsp;
              <b-input-group size="sm">
                <div class="input-group-prepend">
                  <div class="input-group-text vgt-left-btn">Marketplace</div>
                </div>
                <b-form-select v-model="serverParams.marketType" :options="marketplaceOptions"
                  @change="onVGTMarketplaceChange"></b-form-select>
              </b-input-group>
              <!-- &nbsp;
                <b-button
                  href
                  class="vgt-left-btn vgt-green"
                  size="sm"
                  :disabled="serverParams.ids.length < 1"
                  @click="printOrders"
                >Batch Print</b-button> -->
              &nbsp;
              <b-button href class="vgt-left-btn vgt-red" size="sm" :disabled="serverParams.ids.length < 1"
                @click="deleteOrders">Delete</b-button>
              &nbsp;
            </div>

            <div class="form-group form-inline pull-right">
              <b-input-group>
                <b-input class="table-search border-right-0 border" v-model="searchTerm" size="sm"
                  placeholder="Search" />
                <b-input-group-append>
                  <b-button variant="outline-error" class="border-left-0 border" @click="(e) => {
                    if (searchTerm) {
                      searchTerm = '';
                    }
                  }">
                    <i :class="['fa', 'fa-times', { 'opacity-0': !searchTerm }]"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              &nbsp;
              <b-dropdown id="dropdown-1" text="Edit Columns" size="sm" class="vgt-right-btn">
                <b-dropdown-form style="padding-left: 0.5rem">
                  <b-form-checkbox-group v-model="selectedColumns">
                    <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                      {{ col.label }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <b-dropdown-item-button @click="onVGTColumnSelect">
                    <b-button size="sm" class="vgt-right-bnt" block>Apply</b-button>
                  </b-dropdown-item-button>
                </b-dropdown-form>
              </b-dropdown>
            </div>
          </div>
          {{ /* table controllerscontrollers */ }}

          <div class="clearfix"></div>
          {{ /* VGT */ }}
          <vue-good-table ref="vgt" mode="remote" :columns="columns" :rows="rows"
            styleClass="vgt-table striped bordered condensed" max-height="70vh"
            :select-options="{ enabled: true, selectOnCheckboxOnly: true }"
            :search-options="{ enabled: true, externalQuery: searchTerm }"
            :pagination-options="{ enabled: true, mode: 'records', perPageDropdown: [25], dropdownAllowAll: false }"
            :totalRows="totalRecords" :line-numbers="true" @on-search="onVGTSearch"
            @on-selected-rows-change="onVGTSelected" @on-page-change="onVGTPageChange" @on-sort-change="onVGTSortChange"
            @on-column-filter="onVGTColumnFilter" @on-per-page-change="onVGTPerPageChange">
            <div slot="emptystate"> N/A </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'id'">
                <button class="btn btn-primary btn-xs view" @click="showOrder(props.row.id)">View</button>
                <!-- <button class="btn btn-primary btn-xs" @click="trackOrder(props.row.id)">Track</button> -->
              </span>
              <span v-else-if="props.column.field === 'marketplace'">
                <img v-if="props.row.marketplace" v-bind:src="props.row.marketplace.img" class="img-responsive" />
                <span v-else>.</span>
              </span>
              <span v-else-if="props.column.field === 'address'">
                {{ props.row.address.address1 }} <br />
                {{ props.row.address.address2 }} <br />
                {{ props.row.address.address3 }}
              </span>
              <span v-else-if="props.column.field === 'status'">
                {{ $t(props.row.status) }}
              </span>
              <span v-else-if="props.column.field === 'name'">
                <span v-if="props.row.name.name.trim()">
                  {{ props.row.name.name }} <br />
                </span>
                {{ props.row.name.company }}
              </span>
              <span v-else-if="props.column.field === 'age'">
                {{ calculateAge(props.row.created_at) }}
              </span>
              <span v-else-if="props.column.field === 'created_at'">
                {{ props.row.created_at | readableDate }}
              </span>
              <span v-else-if="props.column.field === 'tracking_id'">
                <a :href="props.row.tracking_id.target" target="_blank">{{ props.row.tracking_id.id }}</a>
              </span>
              <!-- <span v-else-if="props.column.field === 'total_price'">
                  {{ format.price( props.row.rate + props.row.insurance_price + props.row.tracking_price ) }}
                </span> -->
              <span
                v-else-if="['declared_value', 'rate', 'insurance_price', 'total_price', 'tracking_price'].includes(props.column.field)">
                {{ format.price(props.row[props.column.field]) }}
              </span>
              <span v-else-if="props.column.field === 'total_weight'">
                {{ getWeight(props.row.total_weight).lb }}lb
                {{ getWeight(props.row.total_weight).oz }}oz
              </span>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

          </vue-good-table>
          {{ /* VGT */ }}

        </b-card>
      </div>
    </div>

    <div>
      <ShowOrder ref="viewOrderModal" :key="shown.id" :orderobj="shown" v-if="shown !== null"
        @saveAndClose="onSaveAndClose"></ShowOrder>
    </div>
  </div>
</template>
<style lang="scss">
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  &+.calendar-root {
    .input-date {
      display: none;
    }

    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}

.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }

  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import ShowOrder from "./ShowPendingModal";
import lStore from './Mixins/lStore';
import moment from "moment";
import Cookies from 'js-cookie';
import hash from 'object-hash';
import { mapGetters, mapActions } from "vuex";
import { VueGoodTable } from 'vue-good-table';

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    ShowOrder,
  },
  data() {
    return {
      isLoading: false,
      isBulkPrint: false,
      // value could be 3 for shipped,4 for voided,5 for returns
      orderType: {
        id: 1,
        name: 'pending',
      },

      // for modal
      shown: null,
      shownObjs: {},
      integrations: [],
      selectedColumns: [
        "marketplace", "order_number", "created_at", "name", "item",
        "shipping_service", "package_type", "total_weight", "total_price",
      ],
      selected: [],
      searchTerm: '',
      serverParams: {
        columns: null,
        marketType: 'all',
        dateRange: null,
        searchTerm: '',
        ids: [],
        columnFilters: null,
        sort: null,
        page: null,
        perPage: null
      },
      marketplaceOptions: [],
      totalRecords: 0,
      rows: [],
      columns: [
        {
          field: 'id', label: "Actions",
          thClass: "vgt-headers narrow",
          sortable: false,
        },
        {
          field: 'marketplace', label: "Marketplace",
          thClass: "vgt-headers",
        },
        {
          field: 'origin_address', label: "Origin Address",
          thClass: "vgt-headers", hidden: true,
        },
        {
          field: 'origin_postal', label: "Origin Postal",
          thClass: "vgt-headers", hidden: true,
        }, {
          field: 'order_number', label: "Order Number",
          thClass: "vgt-headers",
        }, {
          field: 'age', label: "Age",
          thClass: "vgt-headers narrow",
        }, {
          field: 'created_at', label: "Order Date", type: 'date',
          dateInputFormat: 'yyyy-M-dd HH:mm:ss', 'dateOutputFormat': 'MMM dd yyyy HH:mma',
          thClass: "vgt-headers wide",
        }, {
          field: 'name', label: "Recipient",
          thClass: "vgt-headers",
        }, {
          field: 'address', label: "Address",
          thClass: "vgt-headers widest",
          hidden: true,
        }, {
          field: 'shipping_service', label: "Service Class",
          sortable: false,
          thClass: "vgt-headers wider",
        }, {
          field: 'rate', label: "Shipping Rate",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'package_type', label: "Package Type",
          sortable: false,
          thClass: "vgt-headers wider",
        }, {
          field: 'total_weight', label: "Weight",
          sortable: false,
          thClass: "vgt-headers widest",
        }, {
          field: 'dimension', label: "Dimensions",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'tracking_price', label: "Additional Tracking",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        // {
        //   field: 'signature', label: "Signature",
        //   sortable: false, hidden: true,
        //   thClass:"vgt-headers",
        // },
        // {
        //   field: 'insurance', label: "Insurance",
        //   sortable: false, hidden: true,
        //   thClass:"vgt-headers",
        // },
        {
          field: 'declared_value', label: "Declared Value",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'total_price', label: "Total Cost",
          sortable: false,
          thClass: "vgt-headers",
        }, {
          field: 'label_sticky', label: "Custom Field 1",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'label_sticky_2', label: "Custom Field 2",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'email', label: "Email",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'phone', label: "Phone",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }
      ],
    }
  }, // end of data
  computed: {
    ...mapGetters({ serviceOptions: "serviceOptions" }),
    shipping_service_options() {
      return this.$store.state.shipping_services
        .map(shippingService => {
          return {
            value: shippingService.id,
            text: shippingService.name
          };
        })
        .sort((a, b) => {
          return (
            sorting.services[a.value.code] - sorting.services[b.value.code]
          );
        });
    },
    columnSelection() {
      return this.columns.map(v => {
        const { field, label } = v;
        if (v.field !== 'id') return { field, label };
      }).filter(v => !!v);
    },
  },
  async mounted() {
    const cols = lStore.get(`${this.orderType.name}Columns`);
    if (cols) {
      const { columns, selectedColumns } = cols;
      this.columns = columns;
      this.selectedColumns = selectedColumns;
    }
    const pP = lStore.get(`${this.orderType.name}PerPage`);
    if (pP) {
      this.serverParams.perPage = pP;
    }
    await Promise.all([
      this.fetchIntegrations(),
      this.fetchOrders(),
      this.getMarketPlaces(),
      // this.showOrder(12321),
    ]);
  },
  methods: {
    ...mapActions(["addPrintJob", "refreshUserBalance"]),
    // VGT EVENTS
    updateVGTParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onVGTSelected(params) {
      console.log('on select', params);
      if (params.selectedRows.length > 0) {
        const ids = params.selectedRows.map(v => v.id);
        this.updateVGTParams({ ids });
        console.log('on select', ids, this.serverParams.ids);
      } else {
        this.updateVGTParams({ ids: [] });
      }
    },
    onVGTSearch(params) {
      console.log('on search', params);
      this.updateVGTParams({ searchTerm: params.searchTerm });
      this.fetchOrders();
    },
    onVGTPageChange(params) {
      console.log('on pagination', params);
      this.updateVGTParams({ page: params.currentPage });
      this.fetchOrders();
    },
    onVGTPerPageChange(params) {
      console.log('on per page change', params);
      this.updateVGTParams({ perPage: params.currentPerPage });
      lStore.set(`${this.orderType.name}PerPage`, params.currentPerPage);
      // needs to clear everything since since the number of pages is already invalid
      this.fetchOrders();
    },
    onVGTSortChange(params) {
      console.log('on sort change', params);
      if (!params.length) return
      const { field, type } = params[0];
      this.updateVGTParams({ sort: [field, type] });
      this.fetchOrders();
    },
    onVGTColumnFilter(params) {
      console.log('on columnfilter', params);
      this.updateVGTParams(params);
      this.fetchOrders();
    },
    onVGTColumnSelect() {
      console.log('on selectColumns', this.selectedColumns);
      this.columns = this.columns.map(column => {
        if (column.field !== 'id') {
          column.hidden = this.selectedColumns.includes(column.field) ? false : true;
        }
        return column;
      })
      this.updateVGTParams({ columns: this.selectedColumns });
      const cols = Object.assign({}, { columns: this.columns, selectedColumns: this.selectedColumns });
      lStore.set(`${this.orderType.name}Columns`, cols);
    },
    onVGTDateRangeSelected(params) {
      const { end, start } = params;
      console.log('on daterange start', start);
      console.log('on daterange end', end);
      this.updateVGTParams({ dateRange: [start, end] });
      // this.updateVGTParams(params);
      this.fetchOrders();
    },
    onVGTMarketplaceChange() {
      console.log('on marketplace change', this.serverParams.marketType);
      this.fetchOrders();
    }, // VGT EVENTS

    async fetchIntegrations() {
      let url = '/my-integrations';
      try {
        const { data } = await axios.get(url);
        this.integrations = data;
      } catch (e) {
        console.error(e);
      }
    },
    async sync(id) {
      try {
        this.isLoading = true;
        let url = `/sync/integrations/${id}`;
        const response = await axios.get(url);
        console.log('sync response', response);
        await Promise.all([
          this.fetchOrders(),
          this.fetchIntegrations()
        ]);
        this.$emit("alert", {
          message: 'Finish Syncing From Store',
          type: "success"
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchOrders(page_url = `/orders-vgt`) {
      try {
        this.isLoading = true;
        const response = await axios.get(page_url, {
          params: Object.assign({}, { status: this.orderType.id, with_type: this.orderType.name }, this.serverParams)
        });
        const { data: { data, total } } = response;
        console.log(data, total);
        this.totalRecords = total;
        this.rows = data.map(order => {
          return this.mapToRows(order, this.orderType.id);
        });
      } catch (e) {
        console.error('error fetching orders', e);
      } finally {
        this.isLoading = false;
      }
    }, // get data from server
    mapToRows: function (order) {
      const pkgtypes = {
        PKG: 'Package',
        SOFTPACK: 'Cubic Soft Pack',
        FRE: 'Flat Rate Envelope',
        SFRB: 'Small Flat Rate Box',
        FRB: 'Medium Flat Rate Box',
        LFRB: 'Large Flat Rate Box',
        PFRENV: 'Flat Rate Padded Envelope',
        LGLFRENV: 'Flat Rate Legal Envelope',
        MLFRB: 'Military Large Flat Rate Box'
      };
      const origin_name = `${order.origin_first_name || ''} ${order.origin_last_name || ''}`;
      const origin_company = order.origin_company;
      let origin_address = '';

      if (origin_company && origin_name.trim()) origin_address = `${origin_company}, ${origin_name}`;
      else if (origin_company) origin_address = origin_company;
      else origin_address = origin_name;
      const pl = order.package_length;
      const pw = order.package_width;
      const ph = order.package_height;
      return {
        id: order.id,
        marketplace: order.marketplace_id ? {
          img: `/images/integrations/${order.marketplace_code}/table-icon.png`,
          id: order.marketplace_id,
          name: order.marketplace_name
        } : null,
        origin_postal: order.origin_id ? order.origin_postal_origin : '',
        order_number: order.order_number,
        created_at: order.created_at,
        // shipped_at: order.shipped_at,
        name: {
          name: `${order.shipping_address_first_name || ''} ${order.shipping_address_last_name || ''}`,
          company: order.shipping_address_company || ''
        },
        address: {
          address1: `${order.shipping_address_address} ${order.shipping_address_address2 || ''}`,
          address2: `${order.shipping_address_city} ${order.shipping_address_province}`,
          address3: `${order.shipping_address_country} ${order.shipping_address_postal_code}`
        },
        shipping_address_country: order.shipping_address_country, // needed for dropdown
        shipping_service_code: order.shipping_service_code, // needed for dropdown
        shipping_service_id: order.shipping_service_id, // needed for dropdown
        shipping_service: order.shipping_service_name,
        rate: order.rate,
        package_type: order.package_type ? pkgtypes[order.package_type] : '',
        package_type_code: order.package_type,
        total_weight: order.total_weight,
        dimension: (pw && pl && ph) ? `${order.package_length} x ${order.package_width} x ${order.package_height}` : 'N/A',
        tracking_price: order.tracking_price,
        insurance_price: order.insurance_price,
        declared_value: order.declared_value,
        total_price: order.rate + order.tracking_price + order.insurance_price,
        label_sticky: order.label_sticky,
        label_sticky_2: order.label_sticky_2,
        email: order.shipping_address_email,
        phone: order.shipping_address_phone,
        origin_address,
      }
    }, // DATA
    // MARKETPLACE OPTIONS
    async getMarketPlaces() {
      const mOptions = sessionStorage.getItem('marketplace_options');
      if (mOptions) {
        this.marketplaceOptions = JSON.parse(mOptions);
      } else {
        console.log('getting marketplace options');
        const { data } = await axios.get('/marketplaces-vgt');
        console.log('marketplaces', data);
        const marketplaces = data.map(m => {
          const text = `<u>${m.name}</u>`;
          return {
            value: m.id,
            text,
          };
        });

        const options = [{ value: "all", text: "All" }, ...marketplaces];
        console.log('options', options);
        sessionStorage.setItem('marketplace_options', JSON.stringify(options));
        this.marketplaceOptions = options;
      }
    }, // MARKETPLACE OPTIONS

    packageOptions(serviceId, ctry) {
      try {
        var scrules = this.$store.getters.getServiceCarrierRules(ctry);
        let rules = this.$store.getters.getServicePackageRules(serviceId, ctry, true); // filter inactive mail classes
        console.log('rules', serviceId, ctry, rules);

        const flatRates = {
          EM: {
            FRE: "$24.90",
            LGLFRENV: "$25.15",
            PFRENV: "$25.35"
          },
          PM: {
            FRE: "$7.60", // Flat Rate Envelope
            SFRB: "$8.10", // Small Flat Rate Box
            LFRB: "$18.95", // Large Flat Rate Box
            LGLFRENV: "$7.90", // Legal Flat Rate Envelope
            FRB: "$14.00", // Medium Flat Rate Box
            MLFRB: "$18.35", // APO/FPO/DPO
            PFRENV: "$8.30" // Padded Flat Rate Envelope
          }
        };

        // console.log(scrules, rules);
        let options = serviceId ? rules.map(rule => {
          console.log("RULE", rule);
          let name = rule.brandedName;
          // console.log('service id and type', serviceId, rule.parcelType);
          if (
            serviceId in flatRates &&
            rule.parcelType in flatRates[serviceId]
          ) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }
          // console.log('PType name: ', name);

          return {
            value: rule.parcelType,
            text: name
          };
        })
          : [];
        console.log('Package Options', options);

        return _.orderBy(options, "text");
      } catch (e) {
        console.error(e);
      }
    },
    // EDIT FIELD
    async onEditOrder(order, attribute, value) {
      try {
        const orderIndex = this.rows.findIndex(o => o.id === order.id);

        if (orderIndex < 0) {
          return;
        }

        if (attribute === "weight_lb" || attribute === "weight_oz") {
          if (attribute === "weight_lb") {
            value =
              parseFloat(value) * 16 +
              parseFloat(this.$refs["weight_oz_" + order.id].value);
          } else if (attribute === "weight_oz") {
            value =
              parseFloat(value) + this.$refs["weight_lb_" + order.id].value * 16;
          }

          attribute = "total_weight";
        }

        this.rows[orderIndex][attribute] = value;
        let data = {};
        data[attribute] = value;
        // console.log(order.id, data);
        await this.onEditOrderSubmit(order.id, data);
      } catch (e) {
        console.error(e);
      }
    },
    async onEditOrderSubmit(orderId, data) {
      try {
        const order = this.getOrderById(orderId);
        console.log('order', order);
        if (order) {
          this.isLoading = true;
          const response = await axios.patch("/orders/" + orderId, data);
          console.log('edieordersubmit', response);
          this.$emit("alert", {
            message: response.data.message,
            type: "success"
          });
        }
      } catch (e) {
        this.$emit("alert", {
          message: e.message,
          type: "danger"
        });
        console.error(e);
      } finally {
        this.fetchOrders();
        this.isLoading = false;
      }
    },
    getOrderById(orderId) {
      const order = this.rows.find(o => o.id === orderId);
      return order || null;
    },
    onEditOrderReset(e) { },
    showImportModal() {
      this.$refs.importOrdersModal.show();
    },
    async printOrder(orderId) {
      this.isLoading = true;
      // get the id to be deleted in rows later if successful
      try {
        const response = await axios.post("printlabel/" + orderId);
        // this.shipper_addresses = response.data;
        //this.order.label_print = response.data.documents[0].contents;

        // Add to printer
        console.log('print response', response);
        const decoded = response.data;
        decoded.type = ''; // force print?
        this.addPrintJob(decoded);
        // delete the printed order from the list
        // window.open(response.data.label);
      } catch (e) {
        console.error(e);
        let message = e.response.data.message;
        if (e.response.data.errors) {
          message += ": ";
          message += Object.values(e.response.data.errors).join(" ");
        }
        this.$emit("alert", { message: message, type: "danger" });
        // alert(JSON.parse(error.response.data.message)[0].additionalInfo);
      } finally {
        this.isLoading = false;
        if (!this.isBulkPrint) {
          this.fetchOrders();
          this.refreshUserBalance();
        }
      }
    },
    async printOrders() {
      this.isLoading = true;
      this.isBulkPrint = true;
      const ids = this.serverParams.ids;
      ids.forEach(async id => {
        console.log('printing order id: ' + id);
        await this.printOrder(id);
      });
      await Promise.all([
        this.fetchOrders(),
        this.refreshUserBalance()
      ])
      this.isBulkPrint = false;
      this.isLoading = true;
      // print items concurrently
      // await Promise.all(ids.map(id => {
      //   return this.printOrder(id);
      // }));
    },
    async deleteOrders() {
      const ids = this.serverParams.ids;
      try {
        const ids = this.serverParams.ids;
        const msg = `Are you sure you would like to delete the ${ids.length} orders chosen? Orders may repopulate if you update <br />e-commerce store.`;

        if (!Cookies.get(hash(msg))) {
          let dialog = await this.$dialog.confirm(msg, {
            view: "pausable"
          });
          dialog.close();
        }
      } catch (e) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.delete("orders", { data: { orders: ids } });
        console.log('delete response', response);
        this.fetchOrders();
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
        this.serverParams.ids = [];
      }
    },

    async onImported() {
      console.log('onImpted success');
      this.fetchOrders();
      this.$emit("alert", {
        message: "Orders imported!",
        type: "success"
      });
    },
    // MODALS
    showOrder: async function (orderId) {
      try {
        this.isLoading = true;
        // this.isLoading = true;
        const { data } = await axios.get("/orders/" + orderId);
        this.shown = data;
        // this.isLoading = false;
        // wait for the next event cycle before showing modal
        await this.$nextTick();
        this.isLoading = false;
        this.$refs.viewOrderModal.show();
      } catch (e) {
        console.log('view order modal error: ', e.message);
      }
    },
    async onSaveAndClose(data) {
      this.isLoading = true;
      console.log('data form modal', data);
      this.shown = null;
      await this.fetchOrders();
    },
    // onShowOrderHide: async function(){
    //   console.log('closing modal');
    //   this.shown = null;
    // },
    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },
    calculateAge(date) {
      return moment(date).fromNow();
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Pending.vue